import { configureStore } from '@reduxjs/toolkit'
import authSlice from './auth-slice'
import siteSlice from './site-slice';
const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    site: siteSlice.reducer,
  },
});
export default store;